
<template  minapp='mpx' xlang='wxml'>
  <es-drawer-bottom
    title="截止时间"
    show="{{show}}"
    showDefaultNav
    bind:close="closeDeadline"
    class="main"
    customStyle="{{curCustomStyle}}"
  >
    <view class="deadline-drawer-container">
      <view class="deadline-select-group">
        <view
          class="deadline-select-item"
          wx:class="{{{'deadline-select-item-selected': curDeadLine === item.hour}}}"
          wx:for="{{refactorDeadLineList}}"
          wx:key="item.hour"
          bindtap="setCurDeadLine(item)"
        >
          {{ item.text }}
        </view>
      </view>
      <view class="deadline-warning">
        <image
          class="warning-icon"
          src="https://img-hxy021.didistatic.com/static/starimg/img/xzlfGbV4NI1692120398899.png"
        />
        <text class="warning-text"
          >到期未抢到票，订单自动取消，票款原路退回</text
        >
      </view>
      <view class="deadline-button" bindtap="setSelectDeadLine"> 确认 </view>
    </view>
  </es-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { DeadLineList } from '@/utils/constants'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false,
      },
      selectDeadline: {
        type: Number,
        value: 1,
      },
      latestTrainStartTime: {
        type: String,
        value: ''
      }
    },
    attached() {
      this.curDeadLine = this.selectDeadline
    },
    computed: {
      refactorDeadLineList() {
        const targetTime = new Date(this.latestTrainStartTime).getTime()
        const currentTime = new Date().getTime()
        return this.DeadLineList.map(item => {
          return {
            ...item,
            isDisabled: targetTime - currentTime < item.hour * 3600000
          }
        })
      }
    },
    data: {
      curCustomStyle: {
        height: '357px',
      },
      DeadLineList,
      curDeadLine: 0,
    },
    methods: {
      closeDeadline() {
        this.triggerEvent('close')
      },
      setCurDeadLine(item) {
        if(item.isDisabled) {
          return mpx.showToast({
            title: '距离发车时间较近，请重新选择',
            duration: 3500,
            icon: 'error'
          })
        }
        this.curDeadLine = item.hour
      },
      setSelectDeadLine() {
        this.triggerEvent('set', this.curDeadLine)
      },
    },
  })
</script>

<style lang='stylus' scoped>
  .deadline-drawer-container
    padding 4px 0 34px 0
    .deadline-select-group
      display grid
      grid-template-columns 170px 170px
      grid-template-rows 37px 37px
      grid-column-gap 11px
      grid-row-gap 10px
      justify-content center
      margin-bottom 24px
      .deadline-select-item
        width 170px
        height 37px
        border-radius 8px
        background #F6F8FA
        font-family PingFangSC-Regular
        font-size 14px
        line-height 37px
        text-align center
        color #333333
        box-sizing border-box
        &-selected
          border 1px solid #FF5900
          background rgba(254, 245, 234, 0.5)
          font-family PingFangSC-Medium
          color #000
    .deadline-warning
      width 100%
      display flex
      background linear-gradient(0deg, #FFF6F1, #FFF6F1), linear-gradient(270deg, #FFFFFF 3%, #FFF3EB 100%)
      padding 12px 0 14px 20px
      box-sizing border-box
      .warning-icon
        height 14px
        width 14px
        margin-right 5px
      .warning-text
        font-family PingFangSC-Regular
        font-size 12px
        line-height 14px
        color #333
    .deadline-button
      width 351px
      height 48px
      border-radius 8px
      background #FF6400
      margin 16px auto 0 auto
      line-height 48px
      font-size 17px
      font-family PingFangSC-Medium
      color #fff
      text-align center
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom',
    },
  }
</script>